module.exports = __webpack_public_path__ + "img/podcasts.8ae0470b.jpg";